export const dateFormat = 'YYYY-MM-DDTHH:mm:ss'
export const limitDaysInPast = 93 //Days in the past in which the interval for power fetch is 'hour' instead of 'five_minute'
